/**
 * Chat tags often include auto-applied status/outcome values (e.g. "auto_closed",
 * "AI Abandoned", "Auto Closed On 28 Oct 2026", "Human only") that DUPLICATE the
 * status badge and the AI-state badge already shown on a card/header. Those make
 * the UI look cluttered and repetitive, so we hide them and show only genuine
 * topical tags (billing, technical, feature-request, …).
 */
const SYSTEM_TAG_RE =
  /^(auto[\s_-]?closed|closed|open|queued|missed|archived|resolved|unresolved|reopened|escalated|abandoned|ai[\s_-]?abandoned|ai[\s_-]?handled|ai[\s_-]?resolved|closed[\s_-]?by[\s_-]?ai|human[\s_-]?only|assigned|unassigned)\b/i

/** True when a tag merely repeats status/AI-state info shown elsewhere. */
export function isSystemTag(tag: string): boolean {
  return SYSTEM_TAG_RE.test(String(tag || '').trim())
}

/** Only the meaningful, topical tags — system/status tags removed. */
export function topicalTags(tags?: string[] | null): string[] {
  return (Array.isArray(tags) ? tags : []).filter((t) => t && !isSystemTag(t))
}
